export default "__VITE_ASSET__ij6Rk7Kk__"